import { render } from "./SkeletonPersonHeader.vue?vue&type=template&id=adbbe6ca&scoped=true"
const script = {}

import "./SkeletonPersonHeader.vue?vue&type=style&index=0&id=adbbe6ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adbbe6ca"]])

export default __exports__